import "core-js/modules/es.object.to-string.js";

var isObject = function isObject(value) {
  return Object.prototype.toString.call(value) === "[object Object]";
};

export default isObject;